import { useAtom } from 'jotai';
import { useParams } from 'react-router-dom';
import { GetEmpty, GetReview } from 'src/components/get';
import { ExtensionLoadingModal, InstacartRedirectModal } from 'src/components';
import { useRedirectToUpperCase, useScrollToTop } from 'src/hooks';
import { getCartIdAtom } from 'src/store';

export const GetEmbed = () => {
  const [, setCartId] = useAtom(getCartIdAtom);
  const { cartId: cartIdParam } = useParams();

  useScrollToTop();
  useRedirectToUpperCase({
    cartIdParam,
    setCartId,
    pathname: 'embed',
  });

  return (
    <>
      {!cartIdParam ? (
        <GetEmpty page='embed' />
      ) : (
        <div className='bg-primary-dark pt-4'>
          <GetReview page='embed' />
        </div>
      )}

      <ExtensionLoadingModal />
      <InstacartRedirectModal />
    </>
  );
};
